// extracted by mini-css-extract-plugin
module.exports = {"title":"Typography_title__30Urp","psst":"Typography_psst__1wPfm","pointer":"Typography_pointer__21iui","color__tertiary":"Typography_color__tertiary__1O2Pd"};